import * as React from 'react';
import { connect } from 'react-redux';
import { Avatar as CoreAvatar } from 'wix-ui-core/avatar';
import { CLICKING_ON_AVATAR_OPTIONS } from '../../../../constants/settingsConstants';
import { onClickAvatar } from '../../../../actions/headerActions';
import { st, classes } from './Avatar.st.css';

const Avatar = ({
  isMobile,
  user,
  isHeaderLayoutCenter,
  m_isHeaderLayoutCenter,
  clickingOnProfilePicture,
  isDisplayProfilePicture,
  m_isDisplayProfilePicture,
  stories,
  onClickAvatar,
}) => {
  const src = user.profile_picture_url;
  const name = user.username;
  const isStoryIndicator = Boolean(
    clickingOnProfilePicture === CLICKING_ON_AVATAR_OPTIONS.OPEN_STORY &&
      stories &&
      stories.length,
  );
  const isOpenAccount =
    clickingOnProfilePicture === CLICKING_ON_AVATAR_OPTIONS.OPEN_ACCOUNT;
  const isDisplay = isMobile
    ? m_isDisplayProfilePicture
    : isDisplayProfilePicture;
  const isCenter = isMobile ? m_isHeaderLayoutCenter : isHeaderLayoutCenter;
  if (isDisplay && CLICKING_ON_AVATAR_OPTIONS.NOTHING_APPENED) {
    console.log('dd', CLICKING_ON_AVATAR_OPTIONS);
    const avatarElement = document.getElementById('profileAvatar');
    console.log('dd2', avatarElement);
    const coreAvatarElement =
      avatarElement && avatarElement.querySelectorAll('div');
    console.log('dd2', coreAvatarElement);

    coreAvatarElement && coreAvatarElement[0].removeAttribute('role');
    coreAvatarElement && coreAvatarElement[0].removeAttribute('tabindex');
    console.log('dd3', coreAvatarElement);
  }
  if (!isDisplay) {
    return <div id="profileAvatar" />;
  }

  return (
    <div style={{ marginLeft: isMobile ? '-2px' : '-4px' }}>
      <div id="profileAvatar" style={{ height: 'fit-content' }}>
        <CoreAvatar
          className={st(classes.root, {
            isHeaderLayoutCenter: isCenter,
            isStoryIndicator,
            isOpenAccount,
            isMobile,
          })}
          imgProps={src ? { src } : undefined}
          name={name && name[0].toUpperCase()}
          onClick={() => onClickAvatar(isStoryIndicator)}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isMobile: state.appReducer.isMobile,
  user: state.appReducer.user,
  stories: state.appReducer.stories,
  isDisplayProfilePicture: state.settingsReducer.isDisplayProfilePicture,
  m_isDisplayProfilePicture: state.settingsReducer.m_isDisplayProfilePicture,
  isHeaderLayoutCenter: state.settingsReducer.isHeaderLayoutCenter,
  m_isHeaderLayoutCenter: state.settingsReducer.m_isHeaderLayoutCenter,
  clickingOnProfilePicture: state.settingsReducer.clickingOnProfilePicture,
});

const mapDispatchToProps = (dispatch) => ({
  onClickAvatar: (isStoryIndicator) =>
    dispatch(onClickAvatar(isStoryIndicator)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Avatar);
